import { isSameDay } from 'date-fns'
import { useParams } from 'react-router-dom'

import { useGetByTenantAccountAndAccountSourceAccountIdentifierQuery } from '@/api/rtk-api'
import { PresentationalTable } from '@/components/core-v2'
import { TENANT } from '@/const'
import { displayNumber, displayPercentage } from '@/utilities/number'

import { Loading } from './Loading'

const ROW_OPTIONS = [
  { align: 'left', width: '80%' },
  { align: 'right', width: '20%' }
]

export const ParametersTable = () => {
  const { date: stringDate, source, tradeId } = useParams()
  const { data, isLoading } = useGetByTenantAccountAndAccountSourceAccountIdentifierQuery({
    tenant: TENANT,
    accountIdentifier: tradeId,
    accountSource: source
  })

  if (isLoading) return <Loading />

  const snapshot = data.accountSnapShots.find(snapshot =>
    isSameDay(new Date(snapshot.valuationDate), new Date(stringDate))
  )

  if (!snapshot) return null

  return (
    <PresentationalTable
      headerRow={['Name', 'Value']}
      rowOptions={ROW_OPTIONS}
      rows={[
        ['Protection level', displayPercentage(snapshot.protectedLevel, 2)],
        ['Target volatility', displayPercentage(snapshot.targetVolatility, 2)],
        ['Target multiplier', displayNumber(snapshot.targetMultiplier, 2)],
        ['Implied multiplier', displayNumber(snapshot.impliedMultiplier, 2)],
        ['Target leverage ratio', displayNumber(snapshot.targetLeverageRatio, 2)]
      ]}
    />
  )
}
